const DEFAULT_MESSAGE = 'An unknown error occurred while performing client request';

/**
 * Represents any `ApiSauce` error.
 */
export class ClientError extends Error {
  constructor(message: string = DEFAULT_MESSAGE) {
    super(message);
    Object.setPrototypeOf(this, ClientError.prototype);
  }
}

export class ClientErrorWithResponse<T> extends Error {
  statusCode: number;
  response: T;

  constructor(message: string = DEFAULT_MESSAGE) {
    super(message);
    Object.setPrototypeOf(this, ClientErrorWithResponse.prototype);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/error/client-error.ts